import Api from './api'

export default {
    services() {
        return Api()
            .post('/api/services', null, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => response.data)
    },
    alphaServices(alpha) {
        let url = '/api/services/alpha?alpha=' + alpha;
        if (!alpha) {
            url = '/api/services/alpha';
        }
        return Api()
            .post(url, null, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => response.data)
    },
    search(query) {
        return Api()
            .post('/api/services/search?query=' + query, null, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => response.data)
    },
}
